import React from 'react';
import AppLayout from '../components-app/AppLayout';
import OverviewList from '../components-static/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,MobileMenu} from '../components-static/Common';
import {EditSizeLabel,EditableBox,EditableSelect,Box,Select,TextButton,Button} from '../components-static/Input';
import u from '../utilities/Utilities';
import PropTypes from 'prop-types';
import {Spreadsheet} from '../data/Mimetypes';
import '../styles/staff-list.scss';
import moment from 'moment';

export default class AccessList extends React.Component{

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        spreadsheetOptions:[],
        addError:"",
        permissions:{},
        selectMode:false,
    };

    pageData={
        title:"Access",
        permission:"combined",
        permissionField:"security",
        url:"/access-list",
        scrollAnchor:u.getKey(),
    };

    listData={
        deleteURL:"/api/delete-access-entries",
        spreadsheetURL:"/api/generate-access-spreadsheet",
        overviewURL:"/api/get-all-access-entries",
        overviewLabel:"access-list",
        orderByField:"dateTime",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        listOptions:[
            {label:"Tag Setting",ref:"macro",enabled:true,type:"list"},
        ]
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("combined");
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add", mobileLabel:"Add Access Entry",ref:"add",image:"/images/page-menu/add.png",title:"Add new access entry",enabled:(permissions.create==2)},
                {label:"Template", mobileLabel:"Download Template",ref:"download",image:"/images/page-menu/template.png",title:"Download bulk add template",enabled:(permissions.create==2),onClick:this.onDownloadTemplate},
                {label:"Delete", mobileLabel:"Delete Access Entry",ref:"delete",image:"/images/page-menu/delete.png",title:"Delete selected access entries",enabled:(permissions.delete==2)},
                {label:"Spreadsheet", mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
            ]
        })
    };
    
    onMenuOptionClicked=(ref,show,mobileNav)=>{
        if(mobileNav){
            const toggle = (this.mobileSelect != ref);
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && toggle)});
            this.mobileSelect= ((toggle) ? ref : null);
            for(var i=0; i<mobileNav.length; i++){
                const r = mobileNav[i].ref;
                const show = (r == ref);

                if(show){
                    if(mobileNav[i].onClick){
                        mobileNav[i].onClick();
                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,toggle);
                    }
                    else{
                        this.refs[r].show(toggle);
                    }
                }
                else{
                    if(mobileNav[i].onClick) {

                    }
                    else if(mobileNav[i].type == "list"){
                        this.refs['overview'].triggerListOptions(r,false);
                    }
                    else{
                        this.refs[r].show(false);
                    }
                }
            }
        }
        else{
            this.setState({selectMode:((ref=="spreadsheet" || ref=="delete") && show)});
            this.refs[ref].show(show);
        }
    };

    onToggleForm=(ref,show)=>{
        this.refs['menu'].toggleForm(ref,show);
        this.mobileSelect=(show) ? ref : null;
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onRefreshList=()=>{
        this.refs['overview'].onRefreshList();
    };

    onContentGrabbed=(content)=>{
        this.setState({spreadsheetOptions:content.spreadsheetOptions});
    };

    onDownloadTemplate=()=>{
        u.post({
            url:"/api/get-add-access-template",
            data:{},
            success:(callback)=>{
                u.download(callback.filename,callback.filestamp, ()=>{},
                (error,status)=>{
                    console.log(error);
                    this.setState({error:error});
                });
            },
            error:(error,status)=>{
                this.setState({error:error});
            }
        })
    };

    render=()=>{
        const mobileMenu = this.state.pageMenuButtons.concat(this.listData.listOptions);
        return (
            <AppLayout title={this.pageData.title} requiredPermission={this.pageData.permission} requiredField={this.pageData.permissionField} url={this.pageData.url}>
                <div className="page-error">{this.state.error}</div>
                <PageMenu id={this.pageData.scrollAnchor} title={this.pageData.title} ref="menu" buttons={this.state.pageMenuButtons} onMenuOptionClicked={this.onMenuOptionClicked}>
                    <AddEntry scrollAnchor={this.pageData.scrollAnchor} ref="add" reference="add" onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <DeleteListItem scrollAnchor={this.pageData.scrollAnchor} ref="delete" reference="delete" url={this.listData.deleteURL} selected={this.state.selected} onToggleForm={this.onToggleForm} onRefreshList={this.onRefreshList}/>
                    <GenerateSpreadsheet scrollAnchor={this.pageData.scrollAnchor} ref="spreadsheet" url={this.listData.spreadsheetURL} options={this.state.spreadsheetOptions} reference="spreadsheet" selected={this.state.selected} onToggleForm={this.onToggleForm}/>
                </PageMenu>
                <OverviewList ref="overview" selectMode={this.state.selectMode} url={this.listData.overviewURL} label={this.listData.overviewLabel} numRows={this.listData.numRows} orderByField={this.listData.orderByField} orderByType={this.listData.orderByType} onSelectChange={this.onSelectChange} registerReference={this.registerReference} onContentGrabbed={this.onContentGrabbed} onMutatedChange={this.onMutatedChange} checkboxPermissions={this.listData.checkboxPermissions}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <AccessItem key={index} index={index} content={content} onChange={onChange} onContentChange={onContentChange} registerReference={registerRef} permissions={this.state.permissions}/>
                            )
                        }
                    }
                </OverviewList>
                <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked}/>
            </AppLayout>
        )
    }
}

class AccessItem extends React.Component{

    state={
        error:""
    };

    render=()=>{
        const content = this.props.content;

        return (
            <div style={{textAlign:"center"}}>
                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Name:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.userName} ({content.type})</EditSizeLabel>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Contact:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.userContactNumber} / {content.userEmail}</EditSizeLabel>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Tenant:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.tenantName}</EditSizeLabel>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Unit:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.tenantBlock}, {content.tenantUnit}</EditSizeLabel>
                        </div>
                    </div>
                </div>
                <div className="list-segment extended" style={{textAlign:"left"}}>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Date:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{moment(content.dateTime).format("DD MMM YYYY - h:mma")}</EditSizeLabel>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Turnstile:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.turnstileName}</EditSizeLabel>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Action:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.action}</EditSizeLabel>
                        </div>
                    </div>
                    <div className="list-segment-item">
                        <div className="list-segment-label">Result:</div>
                        <div className="list-segment-input">
                            <EditSizeLabel>{content.result}</EditSizeLabel>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

class AddEntry extends React.Component{
    
    state={
        error:"",
        entryData:{}
    };

    addData={
        addType:2,
        bulkAddURL:"/api/add-bulk-access"
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    onComplete=()=>{
        this.setState({error:""});
        this.props.onToggleForm(this.props.reference,false);
    };

    render=()=>{
        return (
            <AddListItem scrollAnchor={this.props.scrollAnchor} ref={this.props.reference} 
                         reference={this.props.reference} addType={this.addData.addType} 
                         index={this.addData.addIndex} label={this.addData.label} bulkURL={this.addData.bulkAddURL} 
                         filetypes={Spreadsheet} url={this.addData.addURL} onToggleForm={this.props.onToggleForm}
                         onRefreshList={this.props.onRefreshList} onComplete={this.onComplete}/>   
        )
    }
}
AddEntry.propTypes={
    scrollAnchor:PropTypes.string,
    onToggleForm:PropTypes.func.isRequired,
    onRefreshList:PropTypes.func.isRequired,
};